

<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";

export default {
	 components: {
		  Layout
	 },
data() {
         return {
            contactus:{},
            errors: {},

           
         };
      },
 mounted() {
         this.fetchContacts();
      },

	 created() {
		  let style = document.createElement('link')
		  style.setAttribute('rel', 'stylesheet')
		  style.setAttribute('href', '/design/terms-of-use.css')
		  document.head.appendChild(style)
	 },

     methods: {

     fetchContacts() {
            let url = "about/contactus";         
            this.$axios
            .get(url)
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.contactus = responseData[0];  
               console.log(this.contacts);

                })
               .catch((err) => console.log(err));
               
      },        
     }  
   }
</script>
<template>
    <layout>
         <!--terms of use-->
      <div class="container-sm">
         <div v-html="contactus.content"></div>
      </div>
    </layout>
</template>